import React from 'react';
import Header from '../../../components/common/Header';
import Footer from '../../../components/common/Footer';

const Layout = ({ children }) => {
  return (
    <div className='layout-main'>
      <div className='layout-main__header'>
        <Header />
      </div>
      <div className='layout-main__body'>{children}</div>
      <div className='layout-main__footer'>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
